// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__m2CQz","container":"styles_container__FyHPS"};